import script from "./Callback.vue?vue&type=script&lang=js"
export * from "./Callback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"src/views/login/Callback.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "62e53365"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62e53365', __exports__)) {
    api.reload('62e53365', __exports__)
  }
  
}


export default __exports__